<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <CustomerForm
          v-model="customer"
          title="Nový zákazník"
          :edit="false"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CustomerForm from '@/components/forms/CustomerForm'

export default {
  name: 'CustomerAdd',
  components: {
    CustomerForm,
  },
  data() {
    return {
      customer: {},
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      getCustomer: 'customer/getCustomer',
      createCustomer: 'customer/createCustomer',
    }),
    save() {
      this.saving = true
      this.createCustomer(this.customer)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'customers.detail',
              params: { customerId: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
